import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { UserService } from '../services/common/UserService';
import { LOGOUT } from '../constants/actions/auth.constants';

const NAME = 'USER';

const changePassword = createAsyncThunk(
    `${NAME}/changePassword`,
    UserService.changePassword,
);

type State = {
    password: {
        loading: boolean;
        uploading: boolean;
        success: boolean;
        error: string | null;
    };
};

const initialState: State = {
    password: {
        loading: false,
        uploading: false,
        success: false,
        error: null,
    },
};

const slice = createSlice({
    name: NAME,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(changePassword.pending, (state) => {
            state.password = {
                ...state.password,
                uploading: true,
                success: false,
                error: null,
            };
        });
        builder.addCase(changePassword.fulfilled, (state) => {
            state.password = {
                ...state.password,
                uploading: false,
                success: true,
            };
        });
        builder.addCase(changePassword.rejected, (state) => {
            state.password = {
                ...state.password,
                uploading: false,
                success: false,
            };
        });
        builder.addCase(LOGOUT, () => initialState);
    },
});

const UserActions = {
    changePassword,
};

export default UserActions;
export const UserReducer = slice.reducer;
